<template lang="pug">
  .crud
    modal-error-catalog(:form="form" :is-add="isModalAdd")
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 Catálogo de Errores:
            span Administra los tipos de error disponibles para revisiones correctivas.
        vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-lg=6 vm-sm=6)
          vm-button(icon="plus" @click="addRecord") Agregar
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(max-height="420px" :data="errorCatalogs")
            template(slot="header")
              vm-input(
                ref="search"
                icon="search"
                size="small"
                placeholder="Buscar por nombre"
                v-model="filters.where.param"
                @keyup.enter="applyFilter(filters)"
                width="300px"
              )
            template(slot="thead")
              vm-th Nombre
              vm-th Acciones
            template(slot-scope="{ data }")
              vm-tr(v-for="(row, index) in data" :key="`error-catalog-${index}`")
                vm-td {{ row.name }}
                vm-td
                  vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                    vm-dropdown-menu
                      vm-dropdown-item.d-flex.justify-content-between(@click="editRecord(row, index)")
                        vm-icon(icon="edit-2-outline")
                        span &nbsp;Editar
                      vm-dropdown-item.d-flex.justify-content-between(@click="deleteRecordConfirm(row)")
                        vm-icon(icon="trash-2-outline")
                        span &nbsp;Eliminar
          vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
</template>

<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters, mapActions } = createNamespacedHelpers('ErrorCatalogs')
const ModalErrorCatalog = () => import('@/components/modals/ModalErrorCatalog.vue')

export default {
  name: 'ErrorCatalogs',
  components: { ModalErrorCatalog },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['name'],
    columnsOrderBy: ['name'],
    attributeModal: 'name',
    filters: {
      where: {
        name: '',
        param: ''
      },
      whereIn: {},
      whereBetween: {},
      betweenDates: {},
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters(['errorCatalogs', 'pagination', 'filterParams'])
  },
  methods: {
    ...mapActions([
      'deleteRecord',
      'loadRecords',
      'setModalVisible',
      'applyFilter',
      'clearFilter'
    ])
  }
}
</script>
